import CustomZObject from './CustomZObject.js';

const MIN_BPM = 50;
const MIN_DETUNE = -2000;
export default class ZPlayback extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        this.newInlet("Playback Speed", ([speed]) => this.onPlaybackSpeed(speed));
        this.bpm = this.sequencerEngine.bpm;
    }

    onPlaybackSpeed(speed) {
        let newBPM  = MIN_BPM + (this.bpm - MIN_BPM)*(1-speed);
        let newDetune = MIN_DETUNE + (0 - MIN_DETUNE)*(1-speed);
        this.sequencerEngine.bpmParameter.set(newBPM, false);

        for (let track of this.sequencerEngine.tracks) {
            if (track.instrument) {
                if (track.instrument.detuneParameter) {
                    track.instrument.detuneParameter.set(newDetune, false);
                }
            } else {
                track.getSamplers().forEach(
                    x => x.detuneParameter.set(newDetune, false));
            }
        }
    }

}

